// extracted by mini-css-extract-plugin
export var askAiIcon = "_n2-9";
export var container = "_n2-0";
export var groupSeparator = "_n2-a";
export var highlight = "_n2-4";
export var resultIcon = "_n2-5";
export var resultItem = "_n2-7";
export var resultSubtitle = "_n2-3";
export var resultTitle = "_n2-2";
export var resultsList = "_n2-1";
export var searchGroup = "_n2-6";
export var selected = "_n2-8";